<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { Icon } from '@shared/ui/icon';
  import { is } from '@shared/utils';
  import type { FieldState } from '@shared/utils/types';

  const dispatch = createEventDispatcher<{
    blur: FocusEvent;
    focus: FocusEvent;
    reset: void;
    input: { search: string };
  }>();

  export let name: string | undefined = undefined;
  export let placeholder: string | undefined = undefined;
  export let value: string = '';
  export let classes: string | undefined = '';
  export let error: string | boolean = false;
  export let inputElement: HTMLInputElement | undefined = undefined;

  let state: FieldState = 'default';

  const onBlur = (e: FocusEvent): void => {
    state = 'default';
    dispatch('blur', e);
  };

  const onFocus = (e: FocusEvent): void => {
    state = 'active';
    dispatch('focus', e);
  };

  const onReset = (): void => {
    value = '';
    dispatch('reset');
  };

  const onInput = (e: Event) => {
    const input = e.target as HTMLInputElement;
    const search = input.value;
    dispatch('input', { search });
  };
</script>

<div
  class="border-default-400 dark:border-dark-400 relative w-full rounded-full border transition-all
	{is(state !== 'active', 'bg-default-200 dark:bg-dark-200', 'bg-default-100 dark:bg-dark-100')}
    {classes}"
>
  <button type="submit" class="absolute bottom-0 left-0 top-0 p-3">
    <Icon name="search" />
  </button>
  <input
    on:change
    on:input="{onInput}"
    on:focus="{onFocus}"
    on:blur="{onBlur}"
    bind:value
    bind:this="{inputElement}"
    {name}
    {placeholder}
    type="text"
    class="text-default-800 placeholder:text-default-500 dark:text-dark-900 w-full flex-1 truncate rounded-full bg-transparent
        py-3 pl-11 outline-none
		{is(value.trim(), 'pr-11', 'pr-3')}
		"
    aria-invalid="{error ? 'true' : undefined}"
  />
  {#if value.trim()}
    <button
      on:click="{onReset}"
      type="reset"
      class="absolute bottom-0 right-0 top-0 p-3 transition-transform hover:scale-125"
    >
      <Icon name="close" />
    </button>
  {/if}
</div>
